<template>
  <div class="tab-content">
    <el-tabs v-model="tabsActive" type="card">
      <el-tab-pane label="BY AUDIO TEST KITCHEN" name="atk">
        <div class="sources-container">
          <div class="sources-item" v-for="(source, sourceIndex) in sources" :key="source._id">
            <div class="source-header">
              <div class="header-info">
                <div class="info-left" @click="toggleSourceSelect(source._id)">
                  <div class="info-icon">
                    <el-icon v-show="!sourceSelect.includes(source._id)"><arrow-down-bold /></el-icon>
                    <el-icon v-show="sourceSelect.includes(source._id)"><arrow-up-bold /></el-icon>
                  </div>
                  <div class="info-title">
                    <span class="title-song">{{ source.name }}</span>
                    <span class="title-writer">{{ source.song_writer }}</span>
                  </div>
                </div>
                <div class="info-right">
                  <div class="info-switch">
                    <el-switch v-model="source.is_active" active-color="#A5C2CB" />
                  </div>
                  <div class="info-order">
                    <el-select
                      v-model="source.order" style="width: 60px;" placeholder=" " size="mini"
                      @change="(val) => {changeSourceOrder(val, source)}"
                    >
                      <el-option v-for="num in sources.length"  :key="num" :label="num" :value="num"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="header-titles">
                <div class="title-item item-source">
                  <span>Source</span>
                </div>
                <div class="title-item item-performer">
                  <span>Performer</span>
                </div>
                <div class="title-item item-active">
                  <span>Active</span>
                </div>
                <div class="title-item item-order">
                  <span>Order</span>
                  <el-icon class="text-icon" :size="16" @click="orderInstruments(sourceIndex)"><bottom /></el-icon>
                </div>
              </div>
            </div>
            <div class="source-content" v-show="sourceSelect.includes(source._id)">
              <div class="instrument-list">
                <div class="instrument-item" v-for="(instrument, instrumentIndex) in source.instruments"  :key="instrument._id">
                  <div class="item-text text-source">
                    <span>{{ instrument.name }}</span>
                  </div>
                  <div class="item-text text-performer">
                    <span>{{ instrument.performer }}</span>
                  </div>
                  <div class="item-text text-active">
                    <div
                      :class="['ca-checkbox', instrument.is_active ? 'active': 'inactive']"
                      @click="toggleInstrumentActive(sourceIndex, instrumentIndex)"
                    ></div>
                  </div>
                  <div class="item-text text-order">
                    <el-select
                      v-model="instrument.order" style="width: 60px;" placeholder=" " size="mini"
                      @change="(val) => {changeInstrumentOrder(val, instrument, sourceIndex)}"
                    >
                      <el-option v-for="num in source.instruments.length"  :key="num" :label="num" :value="num"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-row style="margin-top: 30px;position:fixed;bottom:0;background:#fff;width:100%;padding:10px;">
          <el-button :disabled="noChanged" size="small" class="el-btn-blue" @click="updateSources" :loading="flagLoading.save">SAVE CHANGES</el-button>
          <el-button :disabled="noChanged" size="small" @click="returnBack">CANCEL</el-button>
        </el-row>
      </el-tab-pane>
      <el-tab-pane :label="`BY ${userInfo.master_brand_name || adminBrand.name}`" name="my">
        <div class="my-souces-action">
          <el-button type="text" class="el-btn-blue" @click="syncSongs" :loading="flagLoading.syncSongs">Synchronize Products Songs</el-button>
        </div>
        <div class="sources-container">
          <div class="sources-item" v-for="(source, sourceIndex) in sourcesMy" :key="source._id">
            <div class="source-header">
              <div class="header-info">
                <div class="info-left" @click="toggleSourceMySelect(source._id)">
                  <div class="info-icon">
                    <el-icon v-show="!sourceMySelect.includes(source._id)"><arrow-down-bold /></el-icon>
                    <el-icon v-show="sourceMySelect.includes(source._id)"><arrow-up-bold /></el-icon>
                  </div>
                  <div class="info-title">
                    <span class="title-song">{{ source.name }}</span>
                    <span class="title-writer">{{ source.song_writer }}</span>
                  </div>
                </div>
                <div class="info-right">
                  <div class="info-switch">
                    <el-switch v-model="source.is_active" active-color="#A5C2CB" />
                  </div>
                  <div class="info-order">
                    <el-select
                      v-model="source.order" style="width: 60px;" placeholder=" " size="mini"
                      @change="(val) => {changeSourceMyOrder(val, source)}"
                    >
                      <el-option v-for="num in sourcesMy.length"  :key="num" :label="num" :value="num"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="header-titles">
                <div class="title-item item-source">
                  <span>Source</span>
                </div>
                <div class="title-item item-performer">
                  <span>Performer</span>
                </div>
                <div class="title-item item-active">
                  <span>Active</span>
                </div>
                <div class="title-item item-order">
                  <span>Order</span>
                  <el-icon class="text-icon" :size="16" @click="orderMyInstruments(sourceIndex)"><bottom /></el-icon>
                </div>
              </div>
            </div>
            <div class="source-content" v-show="sourceMySelect.includes(source._id)">
              <div class="instrument-list">
                <div class="instrument-item" v-for="(instrument, instrumentIndex) in source.instruments"  :key="instrument._id">
                  <div class="item-text text-source">
                    <span>{{ instrument.name }}</span>
                  </div>
                  <div class="item-text text-performer">
                    <span>{{ instrument.performer }}</span>
                  </div>
                  <div class="item-text text-active">
                    <div
                      :class="['ca-checkbox', instrument.is_active ? 'active': 'inactive']"
                      @click="toggleMyInstrumentActive(sourceIndex, instrumentIndex)"
                    ></div>
                  </div>
                  <div class="item-text text-order">
                    <el-select
                      v-model="instrument.order" style="width: 60px;" placeholder=" " size="mini"
                      @change="(val) => {changeMyInstrumentOrder(val, instrument, sourceIndex)}"
                    >
                      <el-option v-for="num in source.instruments.length"  :key="num" :label="num" :value="num"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-row style="margin-top: 30px;position:fixed;bottom:0;background:#fff;width:100%;padding:10px;">
          <el-button size="small" class="el-btn-blue" @click="updateSourcesMy" :loading="flagLoading.saveMy">SAVE CHANGES</el-button>
          <el-button size="small" @click="returnBack">CANCEL</el-button>
        </el-row>
      </el-tab-pane>
    </el-tabs>
    <PermissionSources
      :flagVisible="flagVisible.permissionSources" @closeModal="flagVisible.permissionSources = false"
    />
    <PermissionMyAudio
      :flagVisible="flagVisible.permissionMyAudio" @closeModal="flagVisible.permissionMyAudio = false"
    />
  </div>
</template>

<script>
import { reactive } from 'vue'
import { ArrowUpBold, ArrowDownBold, Bottom } from '@element-plus/icons'
import _ from 'lodash'
import PermissionSources from '@/components/instances/permissions/Sources.vue'
import PermissionMyAudio from '@/components/instances/permissions/MyAudio.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'TabSources',
  props: {
    role: String,
    actionItem: Object
  },
  emits: [],
  components: {
    ArrowUpBold,
    ArrowDownBold,
    Bottom,
    PermissionSources,
    PermissionMyAudio
  },
  data () {
    const flagLoading = reactive({
      save: false,
      saveMy: false,
      syncSongs: false
    })
    const flagVisible = reactive({
      permissionSources: false,
      permissionMyAudio: false
    })
    const actionItems = reactive({
    })
    return {
      instance: {},
      sources: [],
      sourcesOld: [],
      sourcesMy: [],
      sourceSelect: [],
      sourceMySelect: [],
      flagLoading,
      flagVisible,
      actionItems,
      tabsActive: 'atk',
      noChanged: true
    }
  },
  created: function () {
  },
  mounted () {
  },
  computed: {
    userInfo: function () {
      return this.$store.getters.userInfo
    },
    ...mapGetters({
      adminBrand: 'adminBrand'
    })
  },
  watch: {
    actionItem: {
      handler: function (val, oldVal) {
        if (val !== oldVal) {
          if (val) this.instance = { ...val }
          if (val && val.sources) {
            const sources = []
            _.sortBy(val.sources, ['order']).map(item => {
              sources.push({ ...item, instruments: _.sortBy(item.instruments, ['order']) })
            })
            this.sources = sources
          }
          if (val && val.my_sources) {
            const sourcesMy = []
            _.sortBy(val.my_sources, ['order']).map(item => {
              sourcesMy.push({ ...item, instruments: _.sortBy(item.instruments, ['order']) })
            })
            this.sourcesMy = sourcesMy
          }
        }
      },
      deep: true
    },
    sources: {
      handler: function (val, oldVal) {
        if (this.sourcesOld.length === 0) {
          this.sourcesOld = JSON.parse(JSON.stringify(this.actionItem.sources))
        }
        if (JSON.stringify(val) !== JSON.stringify(this.sourcesOld)) {
          this.noChanged = false
        } else {
          this.noChanged = true
        }
      },
      deep: true
    }

  },
  methods: {
    updateSources: function () {
      this.flagLoading.save = true
      const url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/instances/${this.instance._id}`
      const that = this
      const sources = []
      this.sources = _.sortBy(this.sources, ['order'])
      this.sources.map(item => {
        const instruments = []
        item.instruments = _.sortBy(item.instruments, ['order'])
        item.instruments.map(instrument => {
          instruments.push({
            instrument_id: instrument._id,
            is_active: instrument.is_active ? 1 : 0,
            order: instrument.order
          })
        })
        sources.push({
          song_id: item._id,
          is_active: item.is_active ? 1 : 0,
          order: item.order,
          instruments
        })
      })
      const body = { sources }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          if (res.msg === 'permission error - sources') {
            that.flagVisible.permissionSources = true
          } else {
            that.$message({ type: 'error', message: res.msg })
          }
        }
        that.flagLoading.save = false
      }).catch(function (err) {
        console.error('updateSources', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.save = false
      })
    },
    updateSourcesMy: function () {
      this.flagLoading.saveMy = true
      const url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/instances/${this.instance._id}`
      const that = this
      const sourcesMy = []
      this.sourcesMy = _.sortBy(this.sourcesMy, ['order'])
      this.sourcesMy.map(item => {
        const instruments = []
        item.instruments = _.sortBy(item.instruments, ['order'])
        item.instruments.map(instrument => {
          instruments.push({
            instrument_id: instrument._id,
            is_active: instrument.is_active ? 1 : 0,
            order: instrument.order
          })
        })
        sourcesMy.push({
          song_id: item._id,
          is_active: item.is_active ? 1 : 0,
          order: item.order,
          instruments
        })
      })
      const body = { my_sources: sourcesMy }
      this.$service.put(url, body).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Update success' })
        } else {
          if (res.msg === 'permission error - my_sources') {
            that.flagVisible.permissionMyAudio = true
          } else {
            that.$message({ type: 'error', message: res.msg })
          }
        }
        that.flagLoading.saveMy = false
      }).catch(function (err) {
        console.error('updateSourcesMy', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.saveMy = false
      })
    },
    returnBack: function () {
      this.$router.go(-1)
    },
    toggleSourceSelect: function (val) {
      if (this.sourceSelect.includes(val)) {
        this.sourceSelect = _.difference(this.sourceSelect, [val])
      } else {
        this.sourceSelect.push(val)
      }
    },
    toggleSourceMySelect: function (val) {
      if (this.sourceMySelect.includes(val)) {
        this.sourceMySelect = _.difference(this.sourceMySelect, [val])
      } else {
        this.sourceMySelect.push(val)
      }
    },
    orderInstruments: function (index) {
      this.sources[index].instruments = _.sortBy(this.sources[index].instruments, ['order'])
    },
    orderMyInstruments: function (index) {
      this.sourcesMy[index].instruments = _.sortBy(this.sourcesMy[index].instruments, ['order'])
    },
    toggleInstrumentActive: function (sourceIndex, instrumentIndex) {
      this.sources[sourceIndex].instruments[instrumentIndex].is_active = !this.sources[sourceIndex].instruments[instrumentIndex].is_active
    },
    toggleMyInstrumentActive: function (sourceIndex, instrumentIndex) {
      this.sourcesMy[sourceIndex].instruments[instrumentIndex].is_active = !this.sourcesMy[sourceIndex].instruments[instrumentIndex].is_active
    },
    syncSongs: function () {
      this.flagLoading.syncSongs = true
      const url = `/api/v1/atk_player/instances/${this.instance._id}/sync_songs`
      const that = this
      this.$service.post(url).then(function (res) {
        if (res.code === 200) {
          that.$message({ type: 'success', message: 'Synchronize success' })
          that.getInstance()
        } else {
          if (res.msg === 'permission error - my_audio') {
            that.flagVisible.permissionMyAudio = true
          } else {
            that.$message({ type: 'error', message: res.msg })
          }
        }
        that.flagLoading.syncSongs = false
      }).catch(function (err) {
        console.error('syncSongs', err)
        that.$message({ type: 'error', message: err.msg })
        that.flagLoading.syncSongs = false
      })
    },
    getInstance: function () {
      const url = `/api/v1/atk_player${this.role === 'admin' ? '/admin' : ''}/instances/${this.instance._id}`
      const that = this
      this.$service.get(url).then(function (res) {
        if (res.code === 200) {
          that.sourcesMy = [...res.data.my_sources]
        } else {
          console.error('getInstance', res.msg)
        }
      }).catch(function (err) {
        console.error('getInstance', err.msg)
      })
    },
    changeSourceOrder: function (val, source) {
      const sourceIndex = _.findIndex(this.sources, item => {
        return item._id === source._id
      })
      if (val < sourceIndex + 1) {
        this.sources.map(item => {
          if ((item.order === val && item._id !== source._id) || (item.order > val && item.order < sourceIndex + 1)) {
            item.order += 1
          }
        })
      } else if (val > sourceIndex + 1) {
        this.sources.map(item => {
          if ((item.order === val && item._id !== source._id) || (item.order > sourceIndex + 1 && item.order < val)) {
            item.order -= 1
          }
        })
      }
      this.sources = _.sortBy(this.sources, ['order'])
    },
    changeSourceMyOrder: function (val, source) {
      const sourceIndex = _.findIndex(this.sourcesMy, item => {
        return item._id === source._id
      })
      if (val < sourceIndex + 1) {
        this.sourcesMy.map(item => {
          if ((item.order === val && item._id !== source._id) || (item.order > val && item.order < sourceIndex + 1)) {
            item.order += 1
          }
        })
      } else if (val > sourceIndex + 1) {
        this.sourcesMy.map(item => {
          if ((item.order === val && item._id !== source._id) || (item.order > sourceIndex + 1 && item.order < val)) {
            item.order -= 1
          }
        })
      }
      this.sourcesMy = _.sortBy(this.sourcesMy, ['order'])
    },
    changeInstrumentOrder: function (val, instrument, sourceIndex) {
      const instrumentIndex = _.findIndex(this.sources[sourceIndex].instruments, (item) => {
        return item._id === instrument._id
      })
      if (val < instrumentIndex + 1) {
        this.sources[sourceIndex].instruments.map(item => {
          if ((item.order === val && item._id !== instrument._id) || (item.order > val && item.order < instrumentIndex + 1)) {
            item.order += 1
          }
        })
      } else if (val > instrumentIndex + 1) {
        this.sources[sourceIndex].instruments.map(item => {
          if ((item.order === val && item._id !== instrument._id) || (item.order > instrumentIndex + 1 && item.order < val)) {
            item.order -= 1
          }
        })
      }
      this.sources[sourceIndex].instruments = _.sortBy(this.sources[sourceIndex].instruments, ['order'])
    },
    changeMyInstrumentOrder: function (val, instrument, sourceIndex) {
      const instrumentIndex = _.findIndex(this.sourcesMy[sourceIndex].instruments, (item) => {
        return item._id === instrument._id
      })
      if (val < instrumentIndex + 1) {
        this.sourcesMy[sourceIndex].instruments.map(item => {
          if ((item.order === val && item._id !== instrument._id) || (item.order > val && item.order < instrumentIndex + 1)) {
            item.order += 1
          }
        })
      } else if (val > instrumentIndex + 1) {
        this.sourcesMy[sourceIndex].instruments.map(item => {
          if ((item.order === val && item._id !== instrument._id) || (item.order > instrumentIndex + 1 && item.order < val)) {
            item.order -= 1
          }
        })
      }
      this.sourcesMy[sourceIndex].instruments = _.sortBy(this.sourcesMy[sourceIndex].instruments, ['order'])
    }
  }
}
</script>
<style lang="scss" scoped>
.ca-checkbox {
  cursor: pointer;
  width: 20px;
  height: 20px;
  border-radius: 3px;
  &.active {
    background: #A5C2CB;
    box-shadow: 0px 4px 4px rgba(0,0,0,0.25);
    border: solid 2px #8BACB4;
  }
  &.inactive {
    background: #F2F2F2;
    box-shadow: 0px 4px 4px rgba(0,0,0,0.25);
    border: solid 2px #E0E0E0;
  }
}
.sources-container {
  width: 80%;
  .sources-item {
    margin-bottom: 32px;
    .source-header {
      background-color: #DBE7EA;
      border-radius: 8px;
      padding: 12px 16px;
      font-size: 16px;
      .header-info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 16px;
        .info-left {
          width: 65%;
          display: flex;
          align-items: center;
          cursor: pointer;
          .info-icon {
            margin-right: 12px;
          }
          .info-title {
            .title-song {
              font-size: 18px;
              font-weight: bold;
              margin-right: 12px;
            }
          }
        }
        .info-right {
          width: 30%;
          display: flex;
          align-items: center;
          justify-content: space-between;
        }
      }
      .header-titles {
        display: flex;
        .title-item {
          font-weight: bold;
          display: flex;
          align-items: center;
          span {
            margin-right: 5px;
          }
          .text-icon {
            cursor: pointer;
          }
          &.item-source { width: 35%; }
          &.item-performer { width: 35%; }
          &.item-active { width: 15%; }
          &.item-order { width: 15%; }
        }
      }
    }
    .source-content {
      .instrument-list {
        padding: 0 16px;
        .instrument-item {
          display: flex;
          align-items: center;
          padding: 12px 0;
          border-bottom: solid 1px #F2F2F2;
          .item-text {
            &.text-source { width: 35%; }
            &.text-performer { width: 35%; }
            &.text-active { width: 15%; }
            &.text-order { width: 15%; }
          }
        }
      }
    }
  }
}
</style>
